export default __webpack_public_path__ + "static/media/shape_top.f4f2be56.svg";